import { render } from "./ItemEditor.vue?vue&type=template&id=50e96c9c&scoped=true"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"

import "./ItemEditor.vue?vue&type=style&index=0&id=50e96c9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e96c9c"]])

export default __exports__